"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.editorialPageFragment = void 0;
var _fetching = require("@ori/fetching");
const editorialPageFragment = exports.editorialPageFragment = (0, _fetching.gql)`
  fragment EditorialPage on EditorialPage {
    __typename
    description
    pageId
    title
    thumbnailUrl
    themeTag
    editorialLink: link {
      relativeUrl
    }
  }
`;
